import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetGuestRideStatsQueryVariables = Types.Exact<{
  where_base: Types.Guestrides_Bool_Exp;
  where_active: Types.Guestrides_Bool_Exp;
  where_upcoming: Types.Guestrides_Bool_Exp;
  where_completed: Types.Guestrides_Bool_Exp;
  where_deleted: Types.Guestrides_Bool_Exp;
}>;


export type GetGuestRideStatsQuery = { __typename?: 'query_root', total: { __typename?: 'guestrides_aggregate', aggregate?: { __typename?: 'guestrides_aggregate_fields', count: number } | null }, active: { __typename?: 'guestrides_aggregate', aggregate?: { __typename?: 'guestrides_aggregate_fields', count: number } | null }, upcoming: { __typename?: 'guestrides_aggregate', aggregate?: { __typename?: 'guestrides_aggregate_fields', count: number } | null }, completed: { __typename?: 'guestrides_aggregate', aggregate?: { __typename?: 'guestrides_aggregate_fields', count: number } | null }, deleted: { __typename?: 'guestrides_aggregate', aggregate?: { __typename?: 'guestrides_aggregate_fields', count: number } | null } };


export const GetGuestRideStatsDocument = gql`
    query GetGuestRideStats($where_base: guestrides_bool_exp!, $where_active: guestrides_bool_exp!, $where_upcoming: guestrides_bool_exp!, $where_completed: guestrides_bool_exp!, $where_deleted: guestrides_bool_exp!) {
  total: guestrides_aggregate(where: $where_base) {
    aggregate {
      count
    }
  }
  active: guestrides_aggregate(where: $where_active) {
    aggregate {
      count
    }
  }
  upcoming: guestrides_aggregate(where: $where_upcoming) {
    aggregate {
      count
    }
  }
  completed: guestrides_aggregate(where: $where_completed) {
    aggregate {
      count
    }
  }
  deleted: guestrides_aggregate(where: $where_deleted) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetGuestRideStatsQuery__
 *
 * To run a query within a React component, call `useGetGuestRideStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGuestRideStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGuestRideStatsQuery({
 *   variables: {
 *      where_base: // value for 'where_base'
 *      where_active: // value for 'where_active'
 *      where_upcoming: // value for 'where_upcoming'
 *      where_completed: // value for 'where_completed'
 *      where_deleted: // value for 'where_deleted'
 *   },
 * });
 */
export function useGetGuestRideStatsQuery(baseOptions: Apollo.QueryHookOptions<GetGuestRideStatsQuery, GetGuestRideStatsQueryVariables> & ({ variables: GetGuestRideStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGuestRideStatsQuery, GetGuestRideStatsQueryVariables>(GetGuestRideStatsDocument, options);
      }
export function useGetGuestRideStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGuestRideStatsQuery, GetGuestRideStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGuestRideStatsQuery, GetGuestRideStatsQueryVariables>(GetGuestRideStatsDocument, options);
        }
// @ts-ignore
export function useGetGuestRideStatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetGuestRideStatsQuery, GetGuestRideStatsQueryVariables>): Apollo.UseSuspenseQueryResult<GetGuestRideStatsQuery, GetGuestRideStatsQueryVariables>;
export function useGetGuestRideStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGuestRideStatsQuery, GetGuestRideStatsQueryVariables>): Apollo.UseSuspenseQueryResult<GetGuestRideStatsQuery | undefined, GetGuestRideStatsQueryVariables>;
export function useGetGuestRideStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGuestRideStatsQuery, GetGuestRideStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGuestRideStatsQuery, GetGuestRideStatsQueryVariables>(GetGuestRideStatsDocument, options);
        }
export type GetGuestRideStatsQueryHookResult = ReturnType<typeof useGetGuestRideStatsQuery>;
export type GetGuestRideStatsLazyQueryHookResult = ReturnType<typeof useGetGuestRideStatsLazyQuery>;
export type GetGuestRideStatsSuspenseQueryHookResult = ReturnType<typeof useGetGuestRideStatsSuspenseQuery>;
export type GetGuestRideStatsQueryResult = Apollo.QueryResult<GetGuestRideStatsQuery, GetGuestRideStatsQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * Multiple root fields (total, active, upcoming, completed, deleted): returns the full response object.
 * @source {@link src/features/guestRides/queries/getGuestRideStats.query.gql}
 */
export async function getGuestRideStats(
  variables: GetGuestRideStatsQueryVariables,
  options?: { executor?: GqlExecutor } & GqlRequestOptions
): Promise<GetGuestRideStatsQuery> {
  const { executor, ...requestOptions } = options ?? {}
  return resolveExecutor(executor).query<GetGuestRideStatsQuery>(
    GetGuestRideStatsDocument,
    variables,
    requestOptions
  )
}